import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function Support({ nextStep, prevStep }) {
  return (
    <>
      <div className="form-navigator-body">
        <div className="row">
          <div className="col-lg-6">
            <div className="secTitle">
              <h5>1. Best Practices/Acheivement during the month</h5>
            </div>

            <div className="row">
              <div className="col">
                <div className="form-group">
                  <input type="text" placeholder="" className="mb-2" />
                  <input type="text" placeholder="" className="mb-2" />
                  <input type="text" placeholder="" className="mb-2" />
                  <input type="text" placeholder="" className="mb-2" />
                  <input type="text" placeholder="" className="mb-2" />
                  <input type="text" placeholder="" className="mb-2" />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="secTitle">
              <h5>2. Support requested from SACS</h5>
            </div>

            <div className="row">
              <div className="col">
                <div className="form-group">
                  <input type="text" placeholder="" className="mb-2" />
                  <input type="text" placeholder="" className="mb-2" />
                  <input type="text" placeholder="" className="mb-2" />
                  <input type="text" placeholder="" className="mb-2" />
                  <input type="text" placeholder="" className="mb-2" />
                  <input type="text" placeholder="" className="mb-2" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="form-navigate-footer">
        <button onClick={prevStep} className="btn btn-outline-secondary">
          Back
        </button>
        <button onClick={nextStep} className="btn btn-dark border-0">
          Next
        </button>
      </div>
    </>
  );
}
